function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgError(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "34px",
    height: "34px",
    viewBox: "0 0 34 34",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "surface1"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(81.176471%,0%,2.745098%)",
      fillOpacity: 1
    },
    d: "M 17 34 C 26.390625 34 34 26.390625 34 17 C 34 7.609375 26.390625 0 17 0 C 7.609375 0 0 7.609375 0 17 C 0 26.390625 7.609375 34 17 34 Z M 15.582031 19.832031 L 14.167969 7.082031 L 19.832031 7.082031 L 18.417969 19.832031 Z M 19.832031 25.5 C 19.832031 27.066406 18.566406 28.332031 17 28.332031 C 15.433594 28.332031 14.167969 27.066406 14.167969 25.5 C 14.167969 23.933594 15.433594 22.667969 17 22.667969 C 18.566406 22.667969 19.832031 23.933594 19.832031 25.5 Z M 19.832031 25.5 "
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgError);
export default __webpack_public_path__ + "static/media/Error.06b61c1686f86e6145714b9de75009a4.svg";
export { ForwardRef as ReactComponent };